interface JsonErrorOptions {
  readonly cause: unknown
}

class JsonError extends Error {
  constructor(message: string, options: JsonErrorOptions) {
    // cause introduced in ES2022
    // @ts-expect-error - super is not typed
    super(message, { cause: options.cause })
    this.name = 'JsonError'
  }
}

export { JsonError }
